// extracted by css-extract-rspack-plugin
var _1 = "E1IPBXB7Db8lzF9N";
var _2 = "vwGPkTUogRfpk4Oy";
export { _1 as "borderRadius", _2 as "contentElement" }
// extracted by css-extract-rspack-plugin
var _1 = "E1IPBXB7Db8lzF9N";
var _2 = "vwGPkTUogRfpk4Oy";
export { _1 as "borderRadius", _2 as "contentElement" }
